module.exports = __webpack_public_path__ + "media/ring.da80ab77.mp3";